module.exports = __webpack_public_path__ + "static/media/AppStore.4deb278d.png";